import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useStore } from '../context/StoreContext';
import { Icons } from '../components/Icons';
import './About.css';

export default function About() {
  const { goShop, openWA } = useStore();
  return (
    <div className="about-page">
      <Helmet>
        <title>Artificial Jewellery Shop in Daska, Sialkot Since 2001 | About Us</title>
        <meta
          name="description"
          content="City Shopping Center &amp; Dulha House has been Daska and Sialkot's trusted artificial jewellery shop since 2001 — American Diamond, zircon and bridal jewellery sets, now online across Pakistan."
        />
        <link rel="canonical" href="https://cityshopingcenter.com/about" />
      </Helmet>

      {/* Hero */}
      <section className="about-hero">
        <div className="about-hero-inner">
          <div className="about-text" data-reveal="left">
            <div className="about-tag">Jewellery Shop · Est. 2001 · Daska, Sialkot, Pakistan</div>
            <h1 className="about-title">JEWELLERY IN DASKA SINCE 2001</h1>
            <p>City Shopping Center & Dulha House has been Daska's most trusted destination for premium jewelry since 2001. Every piece in our collection is personally curated for every woman.</p>
            <p>We believe every woman deserves to shine. Our American Diamond, Zircon and Fancy collections deliver luxury aesthetics for every occasion — from daily wear to complete bridal sets.</p>
            <button className="btn-primary" onClick={() => goShop('All')} style={{marginTop:'1.5rem'}}>Shop Our Collection</button>
          </div>
          <div className="about-image-placeholder" data-reveal="right">{Icons.diamond(100)}</div>
        </div>
      </section>

      {/* Stats */}
      <section className="stats-section" data-reveal="up">
        <div className="section-header center" style={{marginBottom:'3rem'}}>
          <span className="section-tag">By the Numbers</span>
          <h2 className="section-title">OUR LEGACY</h2>
        </div>
        <div className="stats-grid">
          {[['20+','Years of Excellence'],['500+','Happy Customers'],['4','Collections']].map(([n,l]) => (
            <div key={l} className="stat-box">
              <div className="stat-number">{n}</div>
              <div className="stat-label">{l}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Values */}
      <section className="values-section" data-reveal="up">
        <div className="section-wrapper">
          <div className="section-header center">
            <span className="section-tag">Why Choose Us</span>
            <h2 className="section-title">OUR VALUES</h2>
          </div>
          <div className="values-grid">
            {[
              [Icons.star(),'Premium Quality','Every piece is handpicked and quality-verified. We stock only the finest jewelry.'],
              [Icons.diamond(),'Affordable Luxury','Fine-jewelry aesthetics at prices everyone can enjoy. Luxury is for everyone.'],
              [Icons.check(),'Trusted Since 2001','Two decades of honest dealings and genuine care. Daska\'s most trusted jewelry store.'],
            ].map(([icon,h,p]) => (
              <div key={h} className="value-card">
                <div className="value-icon">{icon}</div>
                <div className="value-heading">{h}</div>
                <div className="value-text">{p}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quote */}
      <section className="quote-section" data-reveal="zoom">
        <div className="quote-text">WHERE EVERY WOMAN <em>FINDS HER SPARKLE</em></div>
        <div className="quote-cite">City Shopping Center & Dulha House · Daska</div>
      </section>

      {/* CTA */}
      <div className="cta-band">
        <h2>READY TO SHOP?</h2>
        <p>Browse our full collection or reach out on WhatsApp for personalised assistance</p>
        <div style={{display:'flex',gap:'1rem',justifyContent:'center',flexWrap:'wrap'}}>
          <button className="btn-cta" onClick={() => goShop('All')}>Shop Now</button>
          <button className="btn-cta" onClick={openWA}>{Icons.whatsapp(16)} WhatsApp</button>
        </div>
      </div>
    </div>
  );
}
